// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"813":"598064aff31bcbdb","847":"11aaa4071de757d5"}[chunkId] + ".js";
};